import {Redirect, Route, Switch} from 'wouter'
import {Photos} from './photos'
import {Charts} from './charts'
import {Files} from './files'

// type DashboardContextType = {
//   from: string
//   to: string
// }

// const DashboardContext = createContext<DashboardContextType | undefined>(undefined)

// export function Dashboard({from, to}: PropsWithChildren<DashboardContextType>) {
//   const {user} = useAuth()
//   return (
//     <DashboardContext.Provider value={{from, to}}>
//       <Photos />
//     </DashboardContext.Provider>
//   )
// }

export function Dashboard() {
  return (
    <Switch>
      <Route path='/photos'>
        <Photos />
      </Route>
      <Route path='/charts'>
        <Charts />
      </Route>
      <Route path='/files'>
        <Files />
      </Route>
      <Route path='/'>
        <Redirect to='/photos' />
      </Route>
    </Switch>
  )
}
